import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Box, TextField } from "@mui/material";
import AddAttachment from "app/authentication/SecureMessaging/AddAttachment";
import { CError } from "app/common/CError";
import { Loading } from "app/lib/components/Loading";
import { useFinanceSummaryQuery, useUploadAbaBatchPaymentFileMutation, } from "generated/generated-models";
import { useState } from "react";
import { useNavigate } from "react-router";
export const UploadABABatchPaymentPage = () => {
    const navigate = useNavigate();
    const { data, loading, error } = useFinanceSummaryQuery();
    const [selectedAccountId, setSelectedAccountId] = useState("");
    const [uploadAbaBatchPaymentFileMutation, { data: mutateData, error: mutateError },] = useUploadAbaBatchPaymentFileMutation();
    const [validationError, setValidationError] = useState(false);
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error) {
        return _jsx(CError, { error: "Could not retrieve Account Details" });
    }
    const accountNumbers = data?.financeSummary.Instruments.flatMap((instrument) => instrument.Accounts).map((account) => String(account.Number)) ?? [];
    const handleAccountChange = (val) => {
        if (val === null) {
            return;
        }
        const accountId = data?.financeSummary.Instruments.flatMap((instrument) => instrument.Accounts).find((account) => account.Number === val)?.Id;
        setSelectedAccountId(accountId);
    };
    const handleFileUpload = async (file, data) => {
        const fileType = file.name.split(".").pop()?.toLowerCase();
        if (!fileType || fileType !== "aba") {
            setValidationError(true);
            return;
        }
        const result = await uploadAbaBatchPaymentFileMutation({
            variables: {
                input: {
                    AccountId: selectedAccountId,
                    FileData: {
                        fileSize: file.size,
                        fileName: file.name,
                        data: data,
                    },
                },
            },
        });
        navigate(`/BatchPayments/Edit/${result.data?.aBABatchPaymentFile?.BatchPaymentId}`, { state: result.data?.aBABatchPaymentFile?.Message });
    };
    return (_jsxs("section", { className: "sub-wrap", children: [_jsx("h2", { children: "New Batch Payments" }), _jsx(Autocomplete, { id: "filtered-account-outlined", size: "small", sx: { width: 300 }, options: accountNumbers, getOptionLabel: (option) => (option ? option : ""), onChange: (_e, val) => handleAccountChange(val), renderInput: (params) => (_jsx(TextField, { ...params, label: "From Account", InputLabelProps: { shrink: true } })) }), selectedAccountId && (_jsx(AddAttachment, { label: "", helperText: ".aba files only", onFileUpload: handleFileUpload })), validationError && (_jsx(Box, { mt: "16px", children: _jsx(CError, { error: "There was an error uploading the file due to an incorrect file format. Please try again by uploading a .aba file." }) })), mutateError && (_jsx(Box, { mt: "16px", children: _jsx(CError, { error: `There was an error uploading the file: ${mutateError.message}. Please try again by uploading a .aba file.` }) })), mutateData?.aBABatchPaymentFile &&
                !mutateData.aBABatchPaymentFile.Success && (_jsx(Box, { mt: "16px", children: _jsx(CError, { error: `There was an error uploading the file: ${mutateData.aBABatchPaymentFile.Message}. Please try again by uploading a .aba file.` }) }))] }));
};
